import React from 'react';
import {Select, SelectProps, FormControl, InputLabel, MenuItem ,FormHelperText} from '@material-ui/core'
import { State } from "@idha/idha-utils";

interface StateSelectorProps extends SelectProps {
  stateList:State[],
  helperText?: string,
}

const StateSelector: React.FC<StateSelectorProps> = ({stateList=[] , helperText, error, fullWidth, ...rest}) => {
  return (<FormControl fullWidth error={error}  >
  <InputLabel id="demo-simple-select-label">Estado *</InputLabel>
  <Select
    labelId="states-select-label"
    id="states-select"
    {...rest}
    
  > 
  {stateList.map(state=> <MenuItem key={state.name} value={state.name}>{state.name}</MenuItem>)}
   

  </Select>
  <FormHelperText>{helperText}</FormHelperText>

  </FormControl>);
}

export default StateSelector;